/**
 * Конфигурация окружения.
 *
 * Значения приходят не из `import.meta.env` (вшивается на сборке), а из `/env.js`,
 * который генерирует `docker/entrypoint.sh` при старте контейнера. Благодаря этому
 * один и тот же образ едет в stage и в прод — пересборка на смену адреса API не нужна.
 */
declare global {
  interface Window {
    __ARBUZ_ADMIN_ENV__?: Partial<AdminEnv>;
  }
}

export interface AdminEnv {
  /**
   * Базовый адрес API.
   *
   * В разработке — относительный `/api` через прокси Vite (тот же origin, cookie сессии
   * ходит без CORS). В проде — абсолютный `https://api.arbuz.by`: админка и API живут
   * на разных поддоменах, работает CORS-allowlist бэкенда.
   */
  apiBaseUrl: string;
}

const defaults: AdminEnv = {
  apiBaseUrl: '/api',
};

export const env: AdminEnv = {
  ...defaults,
  ...window.__ARBUZ_ADMIN_ENV__,
};
